import {
  ALL_READINESS_FIELDS,
  FIELD_LABEL,
  isReady,
} from '@client/new/pages/programs/model/programs.readiness';
import { ProgramReadiness } from '@client/new/pages/programs/model/programs.types';

/**
 * Shared readiness gating used by both OTP dropdown and subscription matrix
 * to disable not-ready programs in offer selection. Centralising here keeps
 * UX semantics consistent across both surfaces — a Draft program missing a
 * publication criterion looks and behaves the same in either form.
 *
 * Programs with `null` readiness (legacy / pre-backfill snapshot) are
 * treated as ENABLED. We cannot prove they are not-ready and the
 * deploy-window null state must not punish the user.
 */
export const isProgramNotReady = (
  readiness: ProgramReadiness | null | undefined,
): boolean => (readiness ? !isReady(readiness) : false);

/**
 * Builds the "Missing: Title, Cover image, ..." tooltip listing every unmet
 * criterion in declaration order. Returns an empty string when readiness is
 * null/undefined or all-true — callers should only render the tooltip when
 * `isProgramNotReady` is true.
 */
export const toNotReadyTooltip = (
  readiness: ProgramReadiness | null | undefined,
): string => {
  if (!readiness) return '';
  const missing = ALL_READINESS_FIELDS.filter((field) => !readiness[field]);
  return `Missing: ${missing.map((field) => FIELD_LABEL[field]).join(', ')}`;
};
